import { render, staticRenderFns } from "./PainelAdmin.vue?vue&type=template&id=6e4ada13&scoped=true"
import script from "./PainelAdmin.script.js?vue&type=script&lang=js&external"
export * from "./PainelAdmin.script.js?vue&type=script&lang=js&external"
import style0 from "./PainelAdmin.vue?vue&type=style&index=0&id=6e4ada13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ada13",
  null
  
)

export default component.exports